import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "adk_token";
export const api = axios.create({ baseURL: `${BACKEND}/api` });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const errMsg = (e, fb = "Terjadi kesalahan") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.slice(-1)[0] || ""}: ${x.msg}`).join(", ");
  if (!e?.response) return "Koneksi ke server gagal. Periksa koneksi internet Anda.";
  return fb;
};

export const fileUrl = (p, priv = false) =>
  p ? `${BACKEND}/api/files/${p}${priv ? `?auth=${localStorage.getItem(TOKEN_KEY)}` : ""}` : null;

export const rupiah = (n) => (n > 0 ? `Rp ${Number(n).toLocaleString("id-ID")}` : "Gratis");

export const fmtDate = (s) =>
  s ? new Date(s).toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "-";

export const fmtNum = (n) => (n === null || n === undefined ? "-" : Number(n).toLocaleString("id-ID", { maximumFractionDigits: 2 }));

export const PASS_RULES = {
  none: "Tanpa status kelulusan",
  total: "Berdasarkan nilai total",
  per_subject: "Berdasarkan passing grade setiap materi",
  both: "Gabungan nilai total & passing grade materi",
};
export const METHODS = { benar_salah: "Benar/Salah", skor_pilihan: "Skor per pilihan" };
export const TOTAL_METHODS = { sum: "Penjumlahan langsung", weighted: "Skor berbobot (skala 0–100)" };

export const downloadBlob = async (url, filename, params) => {
  const res = await api.get(url, { params, responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(res.data);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
};

export const downloadText = (text, filename) => {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob(["\ufeff" + text], { type: "text/csv" }));
  a.download = filename;
  a.click();
};
